<template>
  <div style="margin-top:-10px !important">
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <b-row
        class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
        style="height:42px"
      >
        <!-- <b-col m5="1"></b-col> -->
        <b-col cols="3" md="3" xl="3" lg="3" sm="3" xs="3" class="text-left px-0">
          <!--  invoice header details -->

          <!--  invoice no and status name -->
          <h2 class="custom-page-title mb-2 mt-1">{{ list.data.header_details.cus_adv_no}}</h2>
        </b-col>
        <b-col cols="9" md="9" xl="9" lg="9" sm="9" xs="9" class="text-right px-0">
        
            <b-button variant="success" size="sm" class="mr-2" @click="recordpayment()"  v-if="list.data.header_details.allow_pymnt == '0' && RoutePermission(false,'','invoice','paymentsreceived','create')">Record Payment</b-button>
        
          <b-button
            v-if="list.data.header_details.allow_pymnt == '1' && list.data.header_details.excess_amount >0 && RoutePermission(false,'','invoice','paymentsreceived','create')"
            variant="success"
            size="sm"
            class="mr-2"
            v-on:click.stop="callavailableinvoicemodal()"
          >Apply To Invoice</b-button>
       
                <b-button variant="success" size="sm" class="mr-2" @click="recordrefund()"   v-if="list.data.header_details.allow_pymnt == '1' && parseFloat(list.data.header_details.excess_amount) > 0 && RoutePermission(false,'','invoice','paymentsreceived','create')">Refund</b-button>

        
           <b-button variant="primary" 
        size="sm"
        class="mr-2" 
      v-if="RoutePermission(false,'','','paymentsreceived','create')"
        :to="{ name: 'CustomerAdvanceCreate', query:{page_from:'view',old_id:$route.params.id}}">
        New Customer Advance
        </b-button>

          <b-button-group variant="light">
            <b-button
              size="sm"
              v-if="RoutePermission(false,'','invoice','paymentsreceived','update')"
              :to="{ name : 'CustomerAdvanceUpdate',params:{id:$route.params.id},query:{page_from:'view'}}"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>
            <b-button
              variant="light"
              size="sm"
              title="email"
              v-if="RoutePermission(false, '', 'invoice', 'paymentsreceived', 'email')"
                @click="emailstatement()"

            >
             
                <i class="la la-envelope-o la-lg"></i>
             
            </b-button>
            <b-button
              variant="light"
              size="sm"
              title="delete"
              v-if="parseFloat(list.data.header_details.refund_amount) == 0 && RoutePermission(false,'','invoice','paymentsreceived','delete')"
              @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customer advance ?',
                  title : 'Delete Payment - '+list.data.header_details.cus_adv_no,
                  module:'customeradvance/deleteCustomerAdvance',
                  data:JSON.stringify({
                    id : $route.params.id
                  }),
                  RoutePlace:'CustomerAdvance',
                  isRoute:'true',
                  type: 'delete',
                  route_history: customeradvance_index_history,
                })"
            >
              <i class="glyphicon glyphicon-trash"></i>
            </b-button>
            <b-button variant="light" size="sm" title=" print" @click="handlePrint()">
              <i class="la la-print la-lg"></i>
            </b-button>

            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="customeradvance_index_history ? customeradvance_index_history : { name: 'CustomerAdvance' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
            <!-- <a title=" print" id="print_url" size="sm" href="#" class="btn btn-light"></a> -->
          </b-button-group>
          <!-- <a title=" attach" href="#" class="btn btn-light" @click="$router.go(-1)">
            <i class="la la-remove la-lg text-decoration-none"></i>
          </a>-->
        </b-col>
      </b-row>
      <!-- 
      page first block
      -->
      <div class="view-block-tab" style="margin-left:-20px;margin-right:-20px;">
        <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-2 border-tab">
          <!--  payment amount used in invoice tabs -->
          <b-tab
            title="Customer Advance View"
            :title-link-class="{'d-print-none':true}"
            class="p-0"
          >
            <div class="view-block d-print-none mb-4">
              <b-row class="w-100">
                <b-col cols="12" lg="12" md="12" class="py-3 px-0">
                  <div class="d-flex ml-4">
                    <div class="verticalLine5 pl-3 ml-4">
                      <h6>Received Amount</h6>

                      <span>{{ currency_symbol +" "+ parseFloat(list.data.header_details.received_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                    <div class="verticalLine4 pl-3 ml-4">
                      <h6>Available Amount</h6>

                      <span>{{ currency_symbol +" "+ parseFloat(list.data.header_details.allow_pymnt == '1' ? list.data.header_details.excess_amount : 0).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                    <div class="verticalLine3 pl-3 ml-4">
                      <h6>Used Amount</h6>

                      <span>{{ currency_symbol +" "+ parseFloat(list.data.header_details.used_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                    <div class="verticalLine5 pl-3 ml-5">
                      <h6>Refund Amount</h6>

                      <span>{{ currency_symbol +" "+ parseFloat(list.data.header_details.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <StandardPrint
              class="custom-md-width"
              :list="list"
              v-if="cus_adv_settings_details.print.templateId == 23"
              :tax_details="tax_details"
            ></StandardPrint>
            <RetailPrint
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              class="custom-md-width mb-5"
              :tax_details="tax_details"
              :list="list"
              v-if="cus_adv_settings_details.print.templateId == 29"
            ></RetailPrint>
          </b-tab>
          <b-tab
            :title="'Payments ('+list.data.invoice_details_payment.length+')'"
            :title-link-class="{'d-print-none':true}"
            v-if="list.data.invoice_details_payment.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-left"
                        width="20%"
                        style="padding-left:22px !important"
                      >Invoice Number</th>
                      <th>Invoice Date</th>
                      <th class="text-right">Invoice Amount</th>
                      <th class="text-right">Amount</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,index)  in list.data.invoice_details_payment"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td
                        class="text-left"
                        width="20%"
                        style="padding-right:22px !important"
                      >{{item.inv_no }}</td>
                      <td>{{getDateFormat(item.created_date)}}</td>
                      <td
                        class="text-right"
                      >{{ currency_symbol +" "+ parseFloat(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td
                        class="text-right"
                      >{{ currency_symbol +" "+ parseFloat(item.pymnt_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td width="50px" style="padding-right:22px !important">
                        <span v-show="showByIndex === index">
                          <i
                            class="glyphicon glyphicon-trash"
                            @click="deletepaymentreason(index)"
                            v-if="RoutePermission(false,'','invoice','paymentsreceived','delete')"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
          <!--  payment amount refunded details -->
          <b-tab
            :title="'Refund ('+list.data.refund_payment_details.length+')'"
            :title-link-class="{'d-print-none':true}"
            v-if="list.data.refund_payment_details.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th class="text-left" width="20%" style="padding-left:22px !important">Date</th>
                      <th>Payment Mode</th>
                      <th class="text-right">Amount Refunded</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,index) in list.data.refund_payment_details"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td
                        class="text-left"
                        width="20%"
                        style="padding-left:22px !important"
                      >{{getDateFormat(item.pymnt_applied_date) }}</td>
                      <td>{{item.method_name}}</td>
                      <td
                        class="text-right"
                      >{{ currency_symbol +" "+ parseFloat(item.pymnt_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td width="50px" style="padding-left:22px !important">
                        <span v-show="showByIndex === index">
                          <i
                            class="glyphicon glyphicon-trash"
                            @click="deleterefund(index)"
                            v-if="RoutePermission(false,'','invoice','paymentsreceived','delete')"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
      <DeletePaymentRecord
      @recallRecord="recallRecord()"
        v-on:setAmountDetails="updateAmountDetails($event)"
        :PaymentDeleteDetail="PaymentDeleteDetail"
      ></DeletePaymentRecord>
      <DeleteRefundRecord
      @recallRecord="recallRecord()"
        v-on:setRefundAmountDetails="updateRefundAmountDetails($event)"
        :RefundDeleteDetail="RefundDeleteDetail"
        page="payment"
      ></DeleteRefundRecord>
      <!--  paymetn delete modal -->
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :type="globalmodaltype"
        :route_history="route_history"
      />
      <InvoiceAvailable
        :currency="currency_symbol"
        :field="customeradvanceDetails"
        :title="'Apply Customer Advance from '+list.data.header_details.cus_adv_no"
        check="availablecustomeradvanceinvoice"
        submit="updateCustomerAdvanceInvoice"
        :place_of_supply="list.data.header_details.place_of_supply"
        page="customeradvance"
        @checkCustomer="checkCustomer"
      ></InvoiceAvailable>
    </template>
  </div>
</template>

<script>
import getPageTitle from "@/utils/get-page-title"; // to set page title
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import DeletePaymentRecord from "@/components/Modal/InvoiceModal/DeletePaymentRecord"; // modal for deleting created credit used record
import RecordNotFound from "@/pages/Error/RecordNotFound";
import DeleteRefundRecord from "@/components/Modal/InvoiceModal/DeleteRefundRecord"; // modal for deleting created credit used record
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import InvoiceAvailable from "@/components/Modal/InvoiceModal/InvoiceAvailable"; // credits available modal
import { number_to_words } from "@/mixins/NumberToWords";
import $ from "jquery";
import store from "@/store/index";
import Widget from "@/components/Widget/Widget";
import StandardPrint from "@/components/Form/CustomerAdvance/Print/Standard";
import RetailPrint from "@/components/Form/CustomerAdvance/Print/Retail";

export default {
  name: "PaymentView",
  mixins: [notificationMixin],
  data() {
    return {
      showprintlabel: false,
      printlabel: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      showByIndex: null,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      tax_details: [],
      currency_symbol: "",
      org_state: "",
      org_country: "",
      total_in_words: "",
      show_notes: false,
      submit: false,
      customeradvanceDetails: {},
      PaymentDeleteDetail: {},
      deletedpymntrecord: "", // to remove the item from the view page
      RefundDeleteDetail: {},
      deletedrefundrecord: "", // to remove the item from the view page
      route_history: "",
      field: {},
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  components: {
    DeletePaymentRecord,
    Widget,
    DeleteRefundRecord,
    InvoiceAvailable,
    RecordNotFound,
    StandardPrint,
    RetailPrint
  },
  methods: {
    checkCustomer(ev){
      window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: ev.status_message,
            type: ev.status_type,
            showCloseButton: true,
          });
          this.$root.$emit("bv::hide::modal", "availableinvoice");
    },
    getTempProps() {
      this.field = this.$store.state.permission.print_settings_details[
        "Customer Advance"
      ].template_list;
    },
       async recordpayment(){
      await store.dispatch("customeradvance/fetchviewList", parseInt(this.$route.params.id))
        if(this.status_code!=404){
          this.$router.push({
            name : 'CustomerAdvancePaymentForm',
            params:{id:this.$route.params.id},
            query:{page:'cus_adv'}
          })
        }
    },
    async recordrefund(){
      await store.dispatch("customeradvance/fetchviewList", parseInt(this.$route.params.id))
        if(this.status_code!=404){
          this.$router.push({
            name : 'CustomerAdvanceRefund',
            params:{id:this.$route.params.id},
            query:{page:'cus_adv'}
          })
        }
    },
    async emailstatement(){
       await store.dispatch("customeradvance/fetchviewList", parseInt(this.$route.params.id))
        if(this.status_code==200){
        this.$router.push({
                  name:'Email',
                  query:{tns_type:'Customer Advance',tns_date: this.list.data.header_details.pymnt_date,cus_id:this.list.data.header_details.cus_id,cus_name:this.list.data.header_details.cus_name,
                  tns_no:this.list.data.header_details.cus_adv_no,
                  tns_mail:this.list.data.header_details.cus_mail,
                  tns_currency:this.list.data.header_details.cus_currency,
                  id:this.$route.params.id,date_format:this.org_details.date_format}
      });
            }
     },

    async handlePrint() {
      await store.dispatch("customeradvance/fetchviewList", parseInt(this.$route.params.id))
if(this.status_code==200){
      await this.getTempProps();
      document.title =
        this.list.data.header_details.cus_adv_no +
        " / " +
        this.getDateFormat(this.list.data.header_details.pymnt_date);
      var id;
      var style;
      var size;
      if (
        this.cus_adv_settings_details.print.templateId == 23 ||
        this.cus_adv_settings_details.print.templateId == 29
      ) {
        id =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "a4-standard-portrait-page"
              : "a4-standard-landscape-page"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "a5-standard-portrait-page"
              : "a5-standard-landscape-page"
            : "";
        style = "standard";
        size =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "size:A4;"
              : "size:A4 landscape;"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "size:A5;"
              : "size:A5 landscape;"
            : "";
      }
      // else if (this.cus_adv_settings_details.print.templateId == 21) {
      //   id =
      //     this.field.temp_prop.paper_size == 0
      //       ? this.field.temp_prop.orientation == 0
      //         ? "a4-spreadsheet-portrait-page"
      //         : "a4-spreadsheet-landscape-page"
      //       : this.field.temp_prop.paper_size == 1
      //       ? this.field.temp_prop.orientation == 0
      //         ? "a5-spreadsheet-portrait-page"
      //         : "a5-spreadsheet-landscape-page"
      //       : "";
      //   size =
      //     this.field.temp_prop.paper_size == 0
      //       ? this.field.temp_prop.orientation == 0
      //         ? "size:A4;"
      //         : "size:A4 landscape;"
      //       : this.field.temp_prop.paper_size == 1
      //       ? this.field.temp_prop.orientation == 0
      //         ? "size:A5;"
      //         : "size:A5 landscape;"
      //       : "";
      //   style = "spreadsheet";
      // } else {
      //   id =
      //     this.field.temp_prop.paper_size == 0
      //       ? "inch3-thermal-print-page"
      //       : "inch4-thermal-print-page";
      //   style = "retail";
      //   size = "";
      // }
      var win;
      const element = document.getElementById(id);
      var printcontent = "";
      if (this.cus_adv_settings_details.print.templateId == 29) {
        for (var i = 1; i <= 2; i++) {
          this.showprintlabel = await true;
          this.printlabel = await (i == 1 ? "CUSTOMER COPY" : "MERCHANT COPY");
          printcontent +=
            (await ' <div style="page-break-after:always">') +
            element.innerHTML +
            "</div>";
        }
      } else {
        printcontent +=
          (await ' <div style="page-break-after:always">') +
          element.innerHTML +
          "</div>";
      }

      win = window.open(
        "",
        "Title",
        "fullscreen=yes",
        "titlebar=yes",
        "scrollbars=yes"
      );
      win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${process.env.VUE_APP_INVOICE_API_URL}/css/print/${style}.css">
              </head>
              <body class="${id}">
              ${printcontent}
              </body>
            </html>
          `);
      setTimeout(() => {
        win.document.close();
        this.printlabel = "";
        this.showprintlabel = false;
        win.focus();
        win.print();
        win.close();
      }, 1000);
}
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    // call avialbel modal
    async callavailableinvoicemodal() {
        await store.dispatch("general/availablecustomeradvanceinvoice",JSON.stringify({ id: this.$route.params.id })) .then((response)=>{
          if(response.data.code!=200){
              window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message:response.data.status,
              type: response.data.type,
              showCloseButton: true
            });
          }
        else{
      this.customeradvanceDetails = {
        id: this.list.data.header_details.cus_id,
        unused_amount: this.list.data.header_details.excess_amount,
        apply_unused_amount: this.list.data.header_details.excess_amount
      };
      this.$root.$emit("bv::show::modal", "availableinvoice");
      EventBus.$emit("invoicedetails");
        }
        })
    },
    TaxPercent() {
      var taxable =
        (parseFloat(this.list.data.header_details.pymnt_amount) /
          (1 + parseFloat(this.list.data.header_details.tax_percent) / 100)) *
        (parseFloat(this.list.data.header_details.tax_percent) / 100);
      var tax_ids = this.list.data.header_details.tax_ids.split(",");
      this.tax_details = [];
      for (var i = 0; i < tax_ids.length; i++) {
        var taxable_amount =
          parseFloat(this.list.data.header_details.pymnt_amount) /
          (1 + parseFloat(this.tax_main[tax_ids[i]].tax_percent) / 100);
        var percent =
          taxable_amount *
          (parseFloat(this.tax_main[tax_ids[i]].tax_percent) / 100);
        this.tax_details.push({
          label:
            this.tax_main[tax_ids[i]].tax_name +
            " [" +
            this.tax_main[tax_ids[i]].tax_percent +
            "%]",
          value: percent,
          taxable_amount: taxable_amount
        });
      }

      return taxable;
    },
    // delete the selected recorc credti applied
    deleterefund(index) {
      this.$root.$emit("bv::show::modal", "deleterefundpayment");
      this.RefundDeleteDetail = this.list.data.refund_payment_details[index];
      this.deletedrefundrecord = index;
    },
    // get the reason how to delete the payment
    deletepaymentreason(index) {
      this.list.data.invoice_details_payment[index].inv_pymnt_id;
      this.submitted = true;
      store
        .dispatch(
          "invoice/deletepaymentreason",
          JSON.stringify({
            id: this.list.data.invoice_details_payment[index].inv_pymnt_id
          })
        )
        .then(response => {
          if(response.code==200){
          this.$root.$emit("bv::show::modal", "paymentreason");

          this.PaymentDeleteDetail = this.list.data.invoice_details_payment[
            index
          ];
          this.deletedpymntrecord = index;
          // this.$refs["paymentreason"].show();
          }else{
            window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.status,
            type: response.type,
            showCloseButton: true,
          });
          this.recallRecord()
          }
        });
    },
    updateAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.data.header_details.used_amount =
        parseFloat(this.list.data.header_details.used_amount) -
        parseFloat(event.PaymentDeleteDetail.pymnt_applied_amount);
      // add applied amount to available amount
      this.list.data.header_details.excess_amount =
        parseFloat(this.list.data.header_details.excess_amount) +
        parseFloat(event.PaymentDeleteDetail.pymnt_applied_amount);
      //  remove the record from list
      this.list.data.invoice_details_payment.splice(this.deletedpymntrecord, 1);
    },
    updateRefundAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.data.header_details.refund_amount =
        parseFloat(this.list.data.header_details.refund_amount) -
        parseFloat(event.RefundDeleteDetail.pymnt_applied_amount);
      // add applied amount to available amount
      this.list.data.header_details.excess_amount =
        parseFloat(this.list.data.header_details.excess_amount) +
        parseFloat(event.RefundDeleteDetail.pymnt_applied_amount);
      //  remove the record from list
      this.list.data.refund_payment_details.splice(this.deletedrefundrecord, 1);
    }

    // handlePrint() {
    //   document.title =
    //     this.list.data.header_details.pymnt_no +
    //     " / " +
    //     this.getDateFormat(this.list.data.header_details.pymnt_date);
    //   // $(".wrap").css("margin-left", "0px");
    //   window.print();
    //   $(".wrap").css("margin-left", "");
    // }
  },
  created() {
    this.getTempProps();
    document.title = getPageTitle(
      this.list.data.header_details.cus_adv_no + " | " + this.$route.meta.title
    );
    $.each(this.$AppDetails.state_list, (key, value) => {
      if (value["state_id"] == this.org_details.org_state) {
        this.org_state = value["state_name"];
      }
    });
    $.each(this.$AppDetails.country_list, (key, value) => {
      if (value["state_id"] == this.org_details.org_country) {
        this.org_country = value["coutry_name"];
      }
    });
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.data.header_details.cus_currency,
      "currency_symbol"
    );
    (this.total_in_words = this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.data.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(this.list.data.header_details.received_amount)),
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.data.header_details.cus_currency,
        "currency_code_fraction"
      );
    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
    this.initializationMessengerCode();
    this.TaxPercent();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("general/fetchPaymentmethod").then(() => {
      next();
    });
  },
  computed: {
    ...mapState({
      list: state => state.customeradvance.list,
      tax_main: state => state.general.tax_main,
      status_code: state => state.customeradvance.status_code,
      status_message: state => state.customeradvance.status_message,
      status_type: state => state.customeradvance.status_type,
      customeradvance_index_history: state =>
        state.customeradvance.customeradvance_index_history
    }),
    ...mapGetters([
      "org_details",
      "pymnt_settings_details",
      "cus_adv_settings_details",
      "orgCurrencySymbol"
    ])
  }
};
</script>
<style scoped>
.vr {
  border-right: thick solid rgb(190, 184, 184);
  border-width: 1px;
  height: 10px;
  margin-right: 6px;
}
</style>
